<template>
  <div :class="className">
    <div class="client-list-wrap vertical-center horizontal-center">
      <div class="client-id">
        <div class="profile-picture" :style="'background-image: url(' + profileImage +')'">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=">
        </div>
        <h2>{{ companyName }}</h2>
        <!-- Tabs (components/ui/EditorTabs.vue, JDEV-3208); logout is an action, so it sits beside the tablist -->
        <div class="client-tabs-row">
          <editor-tabs v-model="activeTab" :tabs="tabList" id-prefix="clientid" :label="_('User interface')">
            <template #tab="{ tab, inMenu }">
              <span v-if="tab.id === 'userinterfaces' && !inMenu" class="j-tab-label"><span class="hidden-xs">{{ tab.label }}</span><span class="hidden-sm hidden-md hidden-lg">{{ _('User interface') }}</span></span>
              <span v-else :class="inMenu ? 'editor-tabs-menu-label' : 'j-tab-label'">{{ tab.label }}</span>
            </template>
          </editor-tabs>
          <button type="button" class="client-logout" :aria-label="_('Logout')" v-on:click="logout()"><i class="fa fa-fw fa-lock" aria-hidden="true"></i><span class="hidden-xs"> {{ _('Logout') }}</span></button>
        </div>
      
        <!-- Tab panes -->
        <div class="tab-content">
          <div role="tabpanel" aria-labelledby="clientid-tab-userinterfaces" :class="'tab-pane' + (activeTab == 'userinterfaces' ? ' active' : '')" id="userinterfaces" v-if="activeTab === 'userinterfaces'">
            <h3 v-if="false">{{ _('Select a user interface') }}</h3>
            <p style="margin-bottom: 20px">
              <strong v-if="clientMode === 'fixed'">{{ _('A fixed user interface is permanently connected to a single device or browser.') }} {{ _('If you connect to a user interface that is already in use elsewhere, they will be logged out.') }}</strong>
            </p>
            <div v-if="clients">
              <button v-on:click="connectToClient(client)" v-for="client in activeClients" :key="client.id" class="btn btn-success btn-lg btn-client">{{ client.name }}</button>
            </div>
            <a href="#new" role="tab" data-toggle="tab" v-on:click="activeTab = 'new'" v-if="false && canCreateClient()">{{ _('New user interface') }}...</a>
            <a href="javascript:;" v-on:click="showFixedClients" v-if="clientMode === 'default' && fixedClients && fixedClients.length">{{ _('Connect to a fixed user interface') }}...</a>
            <a href="javascript:;" v-on:click="showDefaultClients" v-if="clientMode === 'fixed' && clients && clients.length">{{ _('Connect to a floating user interface') }}...</a>
          </div>
          <div role="tabpanel" aria-labelledby="clientid-tab-new" :class="'tab-pane' + (clients && clients.length && activeTab == 'client' ? '' : ' active')" id="new" v-if="canCreateClient() && activeTab === 'new'">
            <div v-if="canCreateClient()">
              <h3 v-if="false">{{ _('New user interface') }}</h3>
              <div class="form-group">
                <label>{{ _('Name') }}</label>
                <input type="text" class="form-control" v-model="clientName" />
              </div>
              <div class="form-group">
                <label>{{ _('Point of Use') }}</label>
                <select class="form-control" v-model="clientPos">
                  <option v-for="pos in this.poses" :value="pos.id">{{ pos.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label>{{ _('Create from template') }}</label>
                <select class="form-control" v-model="clientTemplate">
                  <option v-for="client in clients" :value="client.id">{{ client.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <button class="btn btn-success" v-on:click="createClient" :disabled="!isSaveButtonEnabled">{{ _('Save and connect') }}</button>
              </div>
            </div>
          </div>
        </div>
        <div class="identifier text-center"><span>{{ _('Identifier') }}:</span> <strong>{{ clientid }}</strong></div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.vertical-center {
  display: flex;
  align-items: center;
  flex-direction: row;
  background-color: #F4F6F6;
}
.horizontal-center {
  justify-content: center;
}
.client-tabs-row {
  display: flex;
  align-items: stretch;
  text-align: left;
}
.client-tabs-row > .editor-tabs {
  flex: 1 1 auto;
  min-width: 0;
}
.client-logout {
  flex: 0 0 auto;
  border: 0;
  background: transparent;
  color: #455964;
  padding: 0 12px;
  min-height: 44px;
  white-space: nowrap;
  box-shadow: inset 0 -1px 0 #ddd; /* continues the rule under the strip */
}
.client-logout:hover {
  color: #000;
  background: rgba(255, 255, 255, 0.6);
}
.client-logout:focus-visible {
  outline: 2px solid #67a037;
  outline-offset: -2px;
}
.identifier {
  font-size: 18px;
  margin-top: 15px;
}
.btn-client {
  display: block;
  width: 100%;
  margin-bottom: 10px;
  /* border-bottom-width: 1px; */
  /* padding-bottom: 10px; */
  white-space: wrap;
}
.btn-client:hover {
  background: #edf0f1;
}
h3 {
  margin-top: 20px;
  margin-bottom: 30px;
  color: #507C97;
  font-size: 20px;
}
.vertical-center > .row {
  flex: 1 0 auto;
}
.tab-content {
  border: 1px solid #FFF;
  padding: 30px 30px;
  border-top: none;
  padding-bottom: 15px;
  background-color: #FFF;
  box-shadow: 1px 1px 3px rgba(0,0,0,0.1);
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
}
.profile-picture {
  display: inline-block;
  min-width: 100px;
  max-width: 350px;
  width: 33%;
  border-radius: 50%;
  margin-bottom: 10px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
h2 {
  margin-top: 20px;
  margin-bottom: 30px;
  color: #507C97;
  font-size: 32px;
}
.profile-picture img {
  width: 100%;
  height: auto;
}
/*
@media (max-width: 991px) {
  .client-id {
    width: 90%;
  }
} */
@media (max-width: 767px) {
  /* The global .client-id min-width (360px) overflowed beside the 42px sidebar; the tab strip fits any width. */
  .client-id {
    min-width: 0;
  }
}
@media (max-width: 991px) {
  .vertical-center {
    padding-top: 30px;
    margin-left: -15px;
    margin-right: -15px;
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>
<script>

import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  data () {
    return {
      clients: [],
      fixedClients: [],
      clientMode: 'default',
      poses: [],
      layouts: [],
      clientName: '',
      clientPos: null,
      clientTemplate: null,
      activeTab: 'client'
    }
  },
  props: ['className', 'column', 'clientid'],
  methods: {
    canConnectToClient (clientId) {
      if (this.canConnectToAnyClient()) {
        return true
      }
      if (this.clientMode === 'default') {
        return this.clients && this.clients.length && this.clients.find(c => parseInt(c.id, 10) === parseInt(clientId, 10))
      }
      return this.fixedClients && this.fixedClients.length && this.fixedClients.find(c => parseInt(c.id, 10) === parseInt(clientId, 10))
    },
    canConnectToAnyClient () {
      if (this.userData && this.userData.userlevel >= 7) {
        return true
      }
      return false
    },
    isLinkedToSingleClient () {
      if (this.userData && this.userData.sharedClient && this.userData.sharedClient.length === 1) {
        return true
      }
      return false
    },
    shopSettings (shopId) {
      return this.allSettings[shopId + '-' + this.locale] || {}
    },
    async logout () {
      try {
        await this.$store.dispatch('logout')
      } catch (e) {
      }
    },
    connectToClient (client, force) {
      return new Promise(async (resolve, reject) => {
        if (force || this.canConnectToClient(client.id)) {
          try {
            let data = {
              id: client.id
            }
            if (parseInt(client.floating)) {
              data.connectIdentifier = this.clientid
            } else {
              data.identifier = this.clientid
            }
            await axios.put(this.baseDomain + this.shopId + '/clients/' + client.id + '.json?apikey=' + this.apiKey, data)
            resolve()
          } catch(e) {
            reject()
          }
        }
      })
    },
    async createClient () {
      if (this.canCreateClient()) {
        let response
        try {
          let data = {
            name: this.clientName
          }
          response = await axios.post(this.baseDomain + this.shopId + '/clients/' + this.clientTemplate + '/copy.json?apikey=' + this.apiKey, data)
        } catch(e) {
          return
        }
        if (response && response.data) {
          let posId = this.clientPos
          if (parseInt(this.clientPos) === 0) {
            let posResponse
            try {
              posResponse = await axios.post(this.baseDomain + this.shopId + '/pos.json?apikey=' + this.apiKey, {
                name: this.clientName
              })
              posId = posResponse.data
            } catch(e) {
              return
            }
          }
          try {
            await axios.put(this.baseDomain + this.shopId + '/clients/' + response.data + '.json?apikey=' + this.apiKey, {
              id: response.data,
              pos: posId,
              floating: 1,
              connectIdentifier: this.clientid
            })
          } catch(e) {}
        }
      }
    },
    canCreateClient () {
      if (this.userData && this.userData.userlevel >= 7) {
        return true
      }
      return false
    },
    showFixedClients () {
      this.clientMode = 'fixed'
    },
    showDefaultClients () {
      this.clientMode = 'default'
    }
  },
  computed: {
    // The tabs for <editor-tabs> (JDEV-3208); "New user interface" only for users who can create one.
    tabList () {
      const tabs = [{ id: 'userinterfaces', label: this._('Select a user interface') }]
      if (this.canCreateClient()) {
        tabs.push({ id: 'new', label: this._('New user interface') })
      }
      return tabs
    },
    activeClients () {
      if (this.clientMode === 'default') {
        return this.clients
      }
      return this.fixedClients
    },
    profileImage () {
      return this.settings.profile_id ? this.baseDomain + this.shopId + '/files/' + this.settings.profile_id + '.' + this.settings.profile_ext : '/img/johku-profile.svg'
    },
    settings () {
      return this.shopSettings(this.shopId)
    },
    companyName () {
      return this.settings.companyname
    },
    isSaveButtonEnabled () {
      return this.clientName && this.clientTemplate
    },
    ...mapGetters(['allSettings', 'apiKey', 'shopId', 'baseDomain', 'user', 'userData', 'locale'])
  },
  async mounted () {
    let response
    if (this.isLinkedToSingleClient()) {
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/clients/' + this.userData.sharedClient[0].id + '.json?apikey=' + this.apiKey)
        await this.connectToClient(response.data, true)
        this.EventBus.$emit('reloadClient')
        return
      } catch(e) {}
    }
    if (this.userData && this.userData.sharedClient && this.userData.sharedClient.length) {
      this.clients = this.userData.sharedClient.sort((a, b) => a.name < b.name ? 1 : -1)
    }
    if (this.canConnectToAnyClient()) {
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/clients.json?available=true&apikey=' + this.apiKey)
        this.clients = response.data.filter(c => parseInt(c.floating)).sort((a, b) => a.name > b.name ? 1 : -1)
      } catch(e) {}
    }
    try {
      response = await axios.get(this.baseDomain + this.shopId + '/clients.json?fixed=true&apikey=' + this.apiKey)
      this.fixedClients = response.data.sort((a, b) => a.name > b.name ? 1 : -1)
    } catch(e) {}
    if((this.clients && this.clients.length) || (this.fixedClients && this.fixedClients.length)) {
      this.activeTab = 'userinterfaces'
    } else {
      this.activeTab = 'new'
    }
    if ((!this.clients || !this.clients.length) && (this.fixedClients && this.fixedClients.length)) {
      this.clientMode = 'fixed'
    }
    if (this.canCreateClient()) {
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/pos.json?apikey=' + this.apiKey)
        this.poses = response.data
        if (this.poses && this.poses.length) {
          this.clientPos = this.poses[0].id
          this.poses.push({
            id: 0,
            name: this._('Create new...'),
            version: 'default'
          })
        }
      } catch(e) {}
      /*
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/layouts.json?apikey=' + this.apiKey)
        this.layouts = response.data
        if (this.layouts && this.layouts.length) {
          this.clientLayout = this.layouts[0].id
        }
      } catch(e) {}
      */
    }
  }
}

</script>